export function downloadJsonArtifact(filename: string, artifact: unknown) {
  if (typeof document === "undefined" || typeof URL === "undefined" || typeof Blob === "undefined") {
    return;
  }

  const blob = new Blob([JSON.stringify(artifact, null, 2)], { type: "application/json" });
  downloadBlobArtifact(filename, blob);
}

export function downloadBlobArtifact(filename: string, blob: Blob) {
  if (typeof document === "undefined" || typeof URL === "undefined") {
    return;
  }

  const href = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = href;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  link.remove();
  URL.revokeObjectURL(href);
}
